import React, { useEffect } from 'react'

import Calendar from '@toast-ui/calendar';
import '@toast-ui/calendar/dist/toastui-calendar.min.css';

const CalendarData = () => {
  useEffect(() => {
    const calendar = new Calendar('#calendar', {
      defaultView: 'month', 
      taskView: true, 
      template: {
				monthDayname: function(dayname) {
					return '<span className="calendar-week-dayname-name">' + dayname.label + '</span>';
				}
			}
    });
  }, []);

  return <div id="calendar"></div>;
}

export default CalendarData